/**
 * User Location Constants
 */
export const LOCATION_PLACEHOLDER = "E.g. Sydney, NSW 2000";
